import React from 'react';
import { ReactiveMap } from '@slicesjs/react-core';
import { createReactBindings } from '@slicesjs/react-core';
import { SliceMount } from './slice-mount';
import { FE_SLICES_CDN } from './constants';

const { SlicesProvider } = createReactBindings();

export const WidgetApp = () => {
  const reactiveMap = new ReactiveMap();
  return (
    <SlicesProvider reactiveMap={reactiveMap} origin={FE_SLICES_CDN}>
      <SliceMount version="latest" />
    </SlicesProvider>
  );
};
